"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPropertyListing$ = exports.AreaPropertyListing$outboundSchema = exports.AreaPropertyListing$inboundSchema = exports.Status$ = exports.Status$outboundSchema = exports.Status$inboundSchema = exports.Status = void 0;
exports.areaPropertyListingToJSON = areaPropertyListingToJSON;
exports.areaPropertyListingFromJSON = areaPropertyListingFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const addresses_js_1 = require("./addresses.js");
const agentattributes_js_1 = require("./agentattributes.js");
const energyefficiencyratings_js_1 = require("./energyefficiencyratings.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const listingevent_js_1 = require("./listingevent.js");
const listingtenure_js_1 = require("./listingtenure.js");
const listingtype_js_1 = require("./listingtype.js");
const ownership_js_1 = require("./ownership.js");
const propertytype_js_1 = require("./propertytype.js");
const stringmeta_js_1 = require("./stringmeta.js");
exports.Status = {
    SoldSTC: "Sold STC",
    Available: "Available",
    Withdrawn: "Withdrawn",
    LetAgreed: "Let Agreed",
    UnderOffer: "Under Offer",
    Reserved: "Reserved",
};
/** @internal */
exports.Status$inboundSchema = z
    .nativeEnum(exports.Status);
/** @internal */
exports.Status$outboundSchema = exports.Status$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Status$;
(function (Status$) {
    /** @deprecated use `Status$inboundSchema` instead. */
    Status$.inboundSchema = exports.Status$inboundSchema;
    /** @deprecated use `Status$outboundSchema` instead. */
    Status$.outboundSchema = exports.Status$outboundSchema;
})(Status$ || (exports.Status$ = Status$ = {}));
/** @internal */
exports.AreaPropertyListing$inboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$inboundSchema),
    agent: z.nullable(agentattributes_js_1.AgentAttributes$inboundSchema),
    council_tax_band: z.nullable(z.string()).optional(),
    days_on_market: z.nullable(z.number().int()),
    days_since_listing: z.nullable(z.number().int()),
    days_to_renewal: z.nullable(z.number().int()),
    description: z.nullable(z.string()).optional(),
    display_address: z.nullable(z.string()),
    distance_from_point: z.nullable(z.number().int()),
    energy_efficiency_rating: z.nullable(energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema)
        .optional(),
    estimated_value: z.nullable(z.number()).optional(),
    estimated_value_rounded: z.nullable(z.number()),
    garden_direction: z.nullable(z.string()).optional(),
    has_hmo: z.nullable(z.boolean()),
    has_reduction: z.nullable(z.boolean()),
    images: z.nullable(z.array(z.string())),
    internal_area_square_metres: z.nullable(z.number().int()).optional(),
    is_available: z.nullable(z.boolean()),
    is_bungalow: z.nullable(z.boolean()).optional(),
    is_latest_listing: z.nullable(z.boolean()),
    is_removed: z.nullable(z.boolean()),
    listed_date: z.nullable(z.string()),
    listing_events: z.nullable(z.array(listingevent_js_1.ListingEvent$inboundSchema)).optional(),
    listing_id: z.nullable(z.string()),
    listing_quality: z.nullable(z.string()).optional(),
    listing_type: z.nullable(listingtype_js_1.ListingType$inboundSchema),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$inboundSchema),
    main_image_url: z.nullable(z.string()),
    number_of_bathrooms: z.nullable(z.number().int()),
    number_of_bedrooms: z.nullable(z.number().int()),
    original_price: z.nullable(z.number().int()),
    outdoor_space_area_square_metres: z.nullable(z.number().int()).optional(),
    ownership: z.nullable(ownership_js_1.Ownership$inboundSchema),
    price: z.nullable(z.number().int()),
    propensity_to_let_score: z.nullable(z.number()).optional(),
    property_type: z.nullable(propertytype_js_1.PropertyType$inboundSchema),
    renewal_date: z.nullable(z.string()),
    source: z.nullable(z.string()).optional(),
    status: z.nullable(exports.Status$inboundSchema),
    street_group_property_id: z.nullable(z.string()),
    tenure: z.nullable(listingtenure_js_1.ListingTenure$inboundSchema).optional(),
    weekly_price: z.nullable(z.number()),
    year_built: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
    years_at_property: z.nullable(z.number().int()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "council_tax_band": "councilTaxBand",
        "days_on_market": "daysOnMarket",
        "days_since_listing": "daysSinceListing",
        "days_to_renewal": "daysToRenewal",
        "display_address": "displayAddress",
        "distance_from_point": "distanceFromPoint",
        "energy_efficiency_rating": "energyEfficiencyRating",
        "estimated_value": "estimatedValue",
        "estimated_value_rounded": "estimatedValueRounded",
        "garden_direction": "gardenDirection",
        "has_hmo": "hasHmo",
        "has_reduction": "hasReduction",
        "internal_area_square_metres": "internalAreaSquareMetres",
        "is_available": "isAvailable",
        "is_bungalow": "isBungalow",
        "is_latest_listing": "isLatestListing",
        "is_removed": "isRemoved",
        "listed_date": "listedDate",
        "listing_events": "listingEvents",
        "listing_id": "listingId",
        "listing_quality": "listingQuality",
        "listing_type": "listingType",
        "main_image_url": "mainImageUrl",
        "number_of_bathrooms": "numberOfBathrooms",
        "number_of_bedrooms": "numberOfBedrooms",
        "original_price": "originalPrice",
        "outdoor_space_area_square_metres": "outdoorSpaceAreaSquareMetres",
        "propensity_to_let_score": "propensityToLetScore",
        "property_type": "propertyType",
        "renewal_date": "renewalDate",
        "street_group_property_id": "streetGroupPropertyId",
        "weekly_price": "weeklyPrice",
        "year_built": "yearBuilt",
        "years_at_property": "yearsAtProperty",
    });
});
/** @internal */
exports.AreaPropertyListing$outboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$outboundSchema),
    agent: z.nullable(agentattributes_js_1.AgentAttributes$outboundSchema),
    councilTaxBand: z.nullable(z.string()).optional(),
    daysOnMarket: z.nullable(z.number().int()),
    daysSinceListing: z.nullable(z.number().int()),
    daysToRenewal: z.nullable(z.number().int()),
    description: z.nullable(z.string()).optional(),
    displayAddress: z.nullable(z.string()),
    distanceFromPoint: z.nullable(z.number().int()),
    energyEfficiencyRating: z.nullable(energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema)
        .optional(),
    estimatedValue: z.nullable(z.number()).optional(),
    estimatedValueRounded: z.nullable(z.number()),
    gardenDirection: z.nullable(z.string()).optional(),
    hasHmo: z.nullable(z.boolean()),
    hasReduction: z.nullable(z.boolean()),
    images: z.nullable(z.array(z.string())),
    internalAreaSquareMetres: z.nullable(z.number().int()).optional(),
    isAvailable: z.nullable(z.boolean()),
    isBungalow: z.nullable(z.boolean()).optional(),
    isLatestListing: z.nullable(z.boolean()),
    isRemoved: z.nullable(z.boolean()),
    listedDate: z.nullable(z.string()),
    listingEvents: z.nullable(z.array(listingevent_js_1.ListingEvent$outboundSchema)).optional(),
    listingId: z.nullable(z.string()),
    listingQuality: z.nullable(z.string()).optional(),
    listingType: z.nullable(listingtype_js_1.ListingType$outboundSchema),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$outboundSchema),
    mainImageUrl: z.nullable(z.string()),
    numberOfBathrooms: z.nullable(z.number().int()),
    numberOfBedrooms: z.nullable(z.number().int()),
    originalPrice: z.nullable(z.number().int()),
    outdoorSpaceAreaSquareMetres: z.nullable(z.number().int()).optional(),
    ownership: z.nullable(ownership_js_1.Ownership$outboundSchema),
    price: z.nullable(z.number().int()),
    propensityToLetScore: z.nullable(z.number()).optional(),
    propertyType: z.nullable(propertytype_js_1.PropertyType$outboundSchema),
    renewalDate: z.nullable(z.string()),
    source: z.nullable(z.string()).optional(),
    status: z.nullable(exports.Status$outboundSchema),
    streetGroupPropertyId: z.nullable(z.string()),
    tenure: z.nullable(listingtenure_js_1.ListingTenure$outboundSchema).optional(),
    weeklyPrice: z.nullable(z.number()),
    yearBuilt: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
    yearsAtProperty: z.nullable(z.number().int()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        councilTaxBand: "council_tax_band",
        daysOnMarket: "days_on_market",
        daysSinceListing: "days_since_listing",
        daysToRenewal: "days_to_renewal",
        displayAddress: "display_address",
        distanceFromPoint: "distance_from_point",
        energyEfficiencyRating: "energy_efficiency_rating",
        estimatedValue: "estimated_value",
        estimatedValueRounded: "estimated_value_rounded",
        gardenDirection: "garden_direction",
        hasHmo: "has_hmo",
        hasReduction: "has_reduction",
        internalAreaSquareMetres: "internal_area_square_metres",
        isAvailable: "is_available",
        isBungalow: "is_bungalow",
        isLatestListing: "is_latest_listing",
        isRemoved: "is_removed",
        listedDate: "listed_date",
        listingEvents: "listing_events",
        listingId: "listing_id",
        listingQuality: "listing_quality",
        listingType: "listing_type",
        mainImageUrl: "main_image_url",
        numberOfBathrooms: "number_of_bathrooms",
        numberOfBedrooms: "number_of_bedrooms",
        originalPrice: "original_price",
        outdoorSpaceAreaSquareMetres: "outdoor_space_area_square_metres",
        propensityToLetScore: "propensity_to_let_score",
        propertyType: "property_type",
        renewalDate: "renewal_date",
        streetGroupPropertyId: "street_group_property_id",
        weeklyPrice: "weekly_price",
        yearBuilt: "year_built",
        yearsAtProperty: "years_at_property",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPropertyListing$;
(function (AreaPropertyListing$) {
    /** @deprecated use `AreaPropertyListing$inboundSchema` instead. */
    AreaPropertyListing$.inboundSchema = exports.AreaPropertyListing$inboundSchema;
    /** @deprecated use `AreaPropertyListing$outboundSchema` instead. */
    AreaPropertyListing$.outboundSchema = exports.AreaPropertyListing$outboundSchema;
})(AreaPropertyListing$ || (exports.AreaPropertyListing$ = AreaPropertyListing$ = {}));
function areaPropertyListingToJSON(areaPropertyListing) {
    return JSON.stringify(exports.AreaPropertyListing$outboundSchema.parse(areaPropertyListing));
}
function areaPropertyListingFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPropertyListing$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPropertyListing' from JSON`);
}
//# sourceMappingURL=areapropertylisting.js.map